import { render, staticRenderFns } from "./AuctionDetail.vue?vue&type=template&id=ba4013e0&scoped=true"
import script from "./AuctionDetail.vue?vue&type=script&lang=js"
export * from "./AuctionDetail.vue?vue&type=script&lang=js"
import style0 from "./AuctionDetail.vue?vue&type=style&index=0&id=ba4013e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4013e0",
  null
  
)

export default component.exports